<template>
  <div>
    <ul>
      <li v-for="post in streamer.all" :key="post.id" :class="post.class" v-show="!streamer.loading">
        <router-link tag="a" :to="{name: 'streamer.detail', params: {id: post.id}}">
          <div class="image text-center"><img :src="post._embedded['wp:featuredmedia'][0].source_url" alt="写真"/>
            <div class="shadow"></div>
            <div class="role text-white" v-html="post.job"></div>
            <div class="name text-white">
              {{ post.title.rendered }}
              </div>
          </div>
          <div class="intro text-white" v-html="post.content.rendered"></div>
        </router-link>
      </li>
    </ul>
    <div class="text-center mt-2" v-show="streamer.loading">
      <vue-loading type="spin" color="#DB1016" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { VueLoading } from 'vue-loading-template'

  export default {
    name: 'streamer',
    components: {
      VueLoading,
    },
    computed: {
      ...mapState('streamer', ['streamer']),
    },
    methods: {
      ...mapActions('streamer', ['getStreamerAll']),
    },
    mounted() {
      this.getStreamerAll()
    },
    filters: {
      truncate(text, stop, clamp) {
        return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
      }
    },
  }
</script>
